import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AuthService } from '@src/app/services/authentication/auth.service';
import * as MOMENT from 'moment';
import { WorkItemsService } from '@app/services/work-items/work-items.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'daggr';
  loadUI: boolean = false;
  constructor( private auth : AuthService, private workItems: WorkItemsService) {}

  ngOnInit() {
    if((!this.auth.isAuthenticated && !(this.auth.auth.signInUserSession.state)) || (!Number.isNaN(this.auth.getIdToken.exp) && MOMENT(new Date(this.auth.getIdToken.exp * 1000)).diff(MOMENT().add(7,'minutes'),'minutes') <= 0)) {
      this.auth.login();
    } else{
      this.loadUI = true;
      if(!('cognito:groups' in this.auth.getIdToken && this.auth.getIdToken['cognito:groups'].length && this.auth.getIdToken['cognito:groups'].includes('daggr')))  {
        alert(`You don't have permission to access Daggr, Please contact administrator`)
        this.auth.signOut();
      }
      this.workItems.auditTrailLoginActions('SIGN_IN',{action_type: 'SIGN_IN'})
    }
  }
  ngAfterViewInit() {
    this.auth.updateRefreshToken();
  }
}
